// The check before a brand deletes a campaign (Dani, 2026-10-12). Only one no
// creator has come near can go (BrandCampaign.deletable), so only that one has
// the button; a live one is paused or finished instead (campaign-run.tsx).

import {useEffect} from 'react';
import type {BrandCampaign} from '../../shared/brand-api';
import {Icon} from '../creator/components/Icon';
import {money} from './format';

export function DeleteCampaignDialog({campaign, busy, onCancel, onConfirm}: {
  campaign: BrandCampaign; busy: boolean; onCancel: () => void; onConfirm: () => void;
}) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);
  const held = campaign.credit?.open ? campaign.credit.reserved_cents - campaign.credit.spent_cents : 0;
  return <div className="switch-layer">
    <div className="switch-backdrop" onClick={onCancel} />
    <div className="card switch-dialog" role="dialog" aria-modal="true" aria-labelledby="delete-title">
      <button className="switch-close" type="button" onClick={onCancel} aria-label="Close"><Icon name="x" size={18} /></button>
      <p className="eyebrow">Delete campaign</p>
      <h2 id="delete-title">Delete “{campaign.title}”?</h2>
      <p className="switch-note"><Icon name="info" size={16} />It leaves your campaigns, and creators can no longer see or apply to it. This can’t be undone.{held > 0 ? ` The ${money(held, 'USD')} it set aside goes back to your credit.` : ''}</p>
      <div className="switch-actions">
        <button className="btn btn-light" type="button" onClick={onCancel}>Keep it</button>
        <button className="btn btn-danger" type="button" disabled={busy} onClick={onConfirm}>{busy ? 'Deleting…' : 'Delete campaign'}</button>
      </div>
    </div>
  </div>;
}
